import React from 'react'
// import { connect } from 'react-redux';
// import { BoxContainer } from '../../style'
import BoxCaption from '../index'
// import ButtonCaption from '../../ButtonCaption'
// import TextCaption from '../../TextCaption'
// import { getOpacityForBoxBorder } from '../../../../../../editSlide/api/boxUtils';
// import { getFigure } from '../../../../../../Utils/boxFigureUtils';

class SubBox extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <BoxCaption
                box={this.props.box}
                captions={this.props.captions}
                key={`caption-${this.props.captionIndex}`}
                slideIndex={this.props.slideIndex}
                captionIndex={this.props.captionIndex}
                widgetDimensions={this.props.widgetDimensions}
                unicalClassName={this.props.unicalClassName}
                lang={this.props.lang}
                locale={this.props.locale}
            />
        )
    }
}

export default SubBox